export default [
    {
      path: '/component',
      name: 'component-read',
      component: () => import('@/views/component/component-list/ComponentList.vue'),
      meta: {
        resource: 'Component',
        action: 'read',
      },
    },
    {
        path: '/component/create',
        name: 'component-create',
        component: () => import('@/views/component/component-form/ComponentForm.vue'),
        meta: {
          resource: 'Component',
          action: 'create',
        },
    },

    {
      path: '/component-group',
      name: 'component-group-read',
      component: () => import('@/views/component/category-list/CategoryList.vue'),
      meta: {
        resource: 'Component',
        action: 'read',
      },
    },
    {
        path: '/component-group/create',
        name: 'component-group-create',
        component: () => import('@/views/component/category-list/CategoryForm.vue'),
        meta: {
          resource: 'Component',
          action: 'create',
        },
    },
    
    
  ]
  